import AppsSidebar from "./AppsSidebar.vue";
import Content from "./Content.vue";
import Header from "./Header.vue";
import Modals from "./Modals.vue";
import Portal from "./Portal.vue";
import Sidebar from "./Sidebar.vue";
import Title from "./Title.vue";
import Simple from "./Simple.vue";

const layoutComponents =  {
    AppsSidebar,
    Content,
    Header,
    Modals,
    Portal,
    Sidebar,
    Title,
    Simple
}

export {
    AppsSidebar as LayoutAppsSidebar,
    Content as LayoutContent,
    Header as LayoutHeader,
    Modals as LayoutModals,
    Portal as LayoutPortal,
    Sidebar as LayoutSidebar,
    Title as LayoutTitle,
    Simple as LayoutSimple,
}

export default layoutComponents;